export const STRIPE_VARIANTS = [
  'default',
  'test',
  'emailtraf',
  'email_ng',
  'variantemail4',
  'cancellation',
  'WP20FBShrtPix',
  'ADQWallPilatesFB20',
  'ADQWallPilatesTT20',
  'ADQWallPilatesPT20',
  'superYouthUpgradePaywall',
  'WPShrt_tr_m1',
  'WPShrt_tr_m2',
  'WP20FBShrt_chlg',
  'WP20FBShrt',
  'tc21_pt',
  'tc21_fb',
  'tc21_fb_chp',
  'jw21_fb_chp',
  'jw21_pt_chp',
  'jw21_tt_chp',
  'jw2_fb_tr',
  'jw2_pt_tr',
  'jw2_fb_chp',
  'jw2_pt_chp',
] as const;

export type TpStripeVariants = (typeof STRIPE_VARIANTS)[number];

export type TpSource =
  | 'facebook'
  | 'twitter'
  | 'google'
  | 'tiktok'
  | 'pinterest';

export type TpPaymentSystem = 'braintree' | 'paddle' | 'stripe';

export type TpVariantObject = {
  variant_name: TpStripeVariants;
  payment_system: TpPaymentSystem;
  source: TpSource;
};

const DEFAULT_PAYMENT_SYSTEM: TpPaymentSystem = 'stripe';

const createVariant = (
  source: TpSource,
  names: TpStripeVariants[],
): TpVariantObject[] =>
  names.map((variant_name) => ({
    variant_name,
    payment_system: DEFAULT_PAYMENT_SYSTEM,
    source,
  }));

// const filterVariantsByPrefix = (prefix: string): TpStripeVariants[] =>
//   STRIPE_VARIANTS.filter((variant) => variant.startsWith(prefix));

export const ALL_VARIANTS: TpVariantObject[] = [
  ...createVariant('facebook', [
    'cancellation',
    'email_ng',
    'emailtraf',
    'test',
    'default',
    'ADQWallPilatesFB20',
    'WP20FBShrt',
    'WP20FBShrtPix',
    'superYouthUpgradePaywall',
    'WPShrt_tr_m1',
    'WPShrt_tr_m2',
    'WP20FBShrt_chlg',
    'tc21_fb',
    'tc21_fb_chp',
    'jw21_fb_chp',
    'jw2_fb_tr',
    'jw2_fb_chp',
  ] as TpStripeVariants[]),
  ...createVariant('pinterest', [
    'ADQWallPilatesPT20',
    'WP20PTShrt',
    'tc21_pt',
    'jw21_pt_chp',
    'jw2_pt',
    'jw2_pt_tr',
    'jw2_pt_chp',
  ] as TpStripeVariants[]),
  ...createVariant('tiktok', [
    'ADQWallPilatesTT20',
    'WP20TTShrt',
    'jw21_tt_chp',
  ] as TpStripeVariants[]),
  ...createVariant('google', ['variantemail4'] as TpStripeVariants[]),
];

// const getPrefixVariants = (prefix: string): TpVariantObject[] => {
//   const prefixVariants = filterVariantsByPrefix(prefix);
//   return ALL_VARIANTS.filter((v) => prefixVariants.includes(v.variant_name));
// };

// Export the specific variant groups using the new helper function
export const SHORT_WALL_PILATES_VARIANTS = ALL_VARIANTS.filter((item) =>
  item.variant_name.includes('Shrt'),
);
export const TAI_CHI_VARIANTS = ALL_VARIANTS.filter((item) =>
  item.variant_name.includes('tc'),
);
export const TRIAL_VARIANTS = new Set(['jw2_fb_tr', 'jw2_pt_tr']);

const JW2_SET = new Set(['jw2_fb_tr', 'jw2_pt_tr', 'jw2_fb_chp', 'jw2_pt_chp']);
export const JAPANESE_WALKING_VARIANTS = ALL_VARIANTS.filter(
  (item) => item.variant_name.includes('jw') && !JW2_SET.has(item.variant_name),
);
export const JAPANESE_WALKING_2_VARIANTS = ALL_VARIANTS.filter((item) =>
  JW2_SET.has(item.variant_name),
);
export const BUNDLE_VARIANTS = ALL_VARIANTS.filter((item) =>
  item.variant_name.includes('Shrt'),
).map((item) => item.variant_name);
